import { Controller } from 'stimulus';

const TRANS = {
  length: 'lengte',
  width: 'breedte',
  height: 'hoogte',
};

class UnitModalController extends Controller {
  connect() {
    this.value = 0;
    this.field = null;
    this.dimension = 'length';
  }

  onFieldChange({ currentTarget }) {
    const value = parseInt(currentTarget.value, 10);
    const field = currentTarget.name;

    if (value >= 175) {
      this.value = value;
      this.field = field;

      this.field = currentTarget;
      this.valueTarget.innerText = value;
      this.dimensionTarget.innerText = TRANS[field];

      $(this.modalTarget).modal('show');
    }
  }

  onTypeClick({ currentTarget }) {
    const unit = currentTarget.dataset.unitType;

    if (unit === 'mm') {
      this.field.value = Math.round(this.value / 10);
    }

    $(this.modalTarget).modal('hide');
  }
}

UnitModalController.targets = [
  'modal',
  'value',
  'dimension',
];

export default UnitModalController;
